<div class="modal-backdrop">
  <div class="modal-dialog modal-md">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">{{ title | translate }}</h4>
      </div>
      <div class="modal-body">
        <div *ngIf="message">{{ message | translate }}</div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="confirm()" attr.aria-label="{{ confirmButton }}">{{ confirmButton |translate }}</button>
      </div>
    </div>
  </div>
</div>
